import {FormControl, FormGroup, Validators} from '@angular/forms';
import {FamilyMemberSchoolFormModel} from './family-member-school-form.model';
import {
  AddressFormBuilder
} from '../../../../../shared/components/address/form-address/form-group/address.form.builder';
import {CzlonekRodzinySzkola} from '../../../../../shared/models/czlonek-rodziny';
import {SharedValidators} from '../../../../../shared/validators/shared-validators';

export class FamilyMemberSchoolFormBuilder {
  public static createFormGroup(
    czlonekRodzinySzkola?: CzlonekRodzinySzkola,
  ): FormGroup<FamilyMemberSchoolFormModel> {
    return new FormGroup<FamilyMemberSchoolFormModel>({
      isDaneSzkoly: new FormControl(!!czlonekRodzinySzkola?.id || false),
      nazwa: new FormControl(czlonekRodzinySzkola?.nazwa || null, [
        Validators.required,
        SharedValidators.doNotBeginWithWhitespace(),
      ]),
      rodzaj: new FormControl(czlonekRodzinySzkola?.rodzaj || null),
      adres: AddressFormBuilder.createFormGroup(
        czlonekRodzinySzkola?.adres || undefined,
      ),
    });
  }

  public static toModel(
    formGroup: FormGroup<FamilyMemberSchoolFormModel>,
  ): CzlonekRodzinySzkola | null {
    if (!formGroup.controls.isDaneSzkoly.value) {
      return null;
    }

    const czlonekRodzinySzkola = new CzlonekRodzinySzkola();

    czlonekRodzinySzkola.nazwa = formGroup.controls.nazwa.value;
    czlonekRodzinySzkola.rodzaj = formGroup.controls.rodzaj.value;
    czlonekRodzinySzkola.adres = AddressFormBuilder.mapAdres(
      formGroup.controls.adres,
    );

    return czlonekRodzinySzkola;
  }
}
